

import { IIsiDtoPlCiaRequest, IIsiDtoPlCiaSource, IsiDtoPlCiaRequest, IsiDtoPlCiaResponse, IsiDtoPlCiaResult } from "../../Dtos/Isilog.IsiComponent.IsiDataTransferObject.IsiPlCia";
import { IIsiUIFlowResultGeneric } from "../Core/IIsiUIFlowResultGeneric";
import { IsiPresentationLogic } from "./IsiPresentationLogic";

export class IsiPlCia extends IsiPresentationLogic {
    constructor() {
        super("IsiPlCiaHandler")
    }

    public async SendRequestToIAAsync(pageName: string, screenId: string, sparkleId: string, language: string, category: string, claimNumber: number| null,  sources:IIsiDtoPlCiaSource[]): Promise<IIsiUIFlowResultGeneric<IIsiDtoPlCiaRequest>> {

        const requestDto = IsiDtoPlCiaRequest.fromJS({
            iaRequest: sources,
            screenId: screenId,
            pageName:pageName,
            sparkleId: sparkleId,
            claimNumber: claimNumber,
            language: language,
            category: category,
            response: IsiDtoPlCiaResponse.fromJS({
                getIaResponse: [IsiDtoPlCiaResult.fromJS({
                    functionId: "mockFunction",
                    iaResponse: "mock response"
                })]
            })
        })

        const result =
            await this.ajaxWithErrorHandling("SendRequestToIA", requestDto, true)


        if (result?.continue === false) {
            return result
        }

        return {
            continue: true,
            result: true,
            reponse: result.reponse
        };
    }

}